import React, { Component } from "react";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Glyphicon,
  Jumbotron
} from "react-bootstrap";
import intl from "react-intl-universal";
import LoaderButton from "./LoaderButton";
import DivsPattern from "./skylineDesignPattern";
import { Link } from "react-router-dom";

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      confirmPassword: "",
      isConfirming: false,
      confirmed: false,
      failedMessage: "",
      isChangePasswordFailed: false,
      confirmedPasswordDisabled:true,
      passwordInputType: "password",
      confirmPasswordInputType: "password",
    };
  }

  validateResetForm() {
    var mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return (
      this.state.password.length > 0 &&
      this.state.password === this.state.confirmPassword &&
      mediumRegex.test(this.state.password)
    );
  }

  handleChange = event => {
    var mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    if (event.target.id.includes("password")){
      if (!mediumRegex.test(event.target.value)){
        this.setState({ isChangePasswordFailed: true ,confirmedPasswordDisabled:true});
        this.setState({ failedMessage: intl.get("Password_Illegal") });
      }
      else{
        if(this.state.confirmPassword != event.target.value){
          this.setState({ isChangePasswordFailed: true, confirmedPasswordDisabled:false });
          this.setState({ failedMessage: intl.get("Password_Not_Match") });
        }else{
          this.setState({ isChangePasswordFailed: false, confirmedPasswordDisabled:false });
          this.setState({ failedMessage: "" });
        }
      }
    }

    if (event.target.id.includes("confirmPassword")){
      if (event.target.value !== this.state.password){
        this.setState({ isChangePasswordFailed: true });
        this.setState({ failedMessage: intl.get("Password_Not_Match") });
      }
      else{
        if (!mediumRegex.test(event.target.value)){
          this.setState({ isChangePasswordFailed: true ,confirmedPasswordDisabled:true});
          this.setState({ failedMessage: intl.get("Password_Illegal") });
        }
        else {
          this.setState({ isChangePasswordFailed: false });
          this.setState({ failedMessage: "" });
        }
      }
    }
    if (!event.target.id.includes("confirmPassword") && !event.target.id.includes("newPassword") ){
      if (event.target.value.length >= 8){
        this.setState({confirmedPasswordDisabled:false});
      }
      else{
        this.setState({confirmedPasswordDisabled:true});
      }
    }

    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleConfirmClick = async event => {
    event.preventDefault();
    const queryString = new URLSearchParams(this.props.location.search);
    const queryToken = queryString.get("token");

    this.setState({ isConfirming: true });

    fetch(process.env.REACT_APP_API_URL + "changePassword", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        newPassword: this.state.password,
        token: queryToken
      })
    })
      .then(res => res.json())
      .then(result => {
        if (result.Result.toLowerCase() === "success") {
          this.setState({ confirmed: true });
          this.setState({ isConfirming: false });
        } else {
          this.setState({ confirmed: false });
          this.setState({ isConfirming: false });

          if (result.Result === "Validation") {
            switch (result.Validations[0].ValidationCode.toString()) {
              case "PasswordIllegal":
                this.setState({ failedMessage: intl.get("Password_Illegal") });
                break;
              default:
                this.setState({ failedMessage: intl.get("General_Failure") });
                break;
            }
          } else this.setState({ failedMessage: intl.get("General_Failure") });
        }
      })
      .catch(error => {
        console.error(error);
        this.setState({ isConfirming: false });
        this.props.handleServerError(true);
      });
  };

  renderConfirmationForm() {
    return (
      <DivsPattern headerText={intl.get("Change_Password_Title")}>
        <form onSubmit={this.handleConfirmClick}>
          <FormGroup controlId="password" className="form-label-group">
            <FormControl
              type={this.state.passwordInputType}
              value={this.state.password}
              onChange={this.handleChange}
              placeholder={intl.get("New_Password")}
              className="form-control"
              required
            />
            <a
              onClick={(event) => {
              this.state.passwordInputType === "password"
                ? this.setState({ passwordInputType: "text" })
                : this.setState({ passwordInputType: "password" });
              }}
            >
              <i
              className={
                this.state.passwordInputType === "password"
                ? "fa fa-eye-slash fa-flip-horizontal"
                : "fa fa-eye"
              }
              style={{
                color: "gray",
                right: "16px",
                position: "absolute",
                top: "17px",
              }}
              aria-hidden="true"
              />
            </a>
          </FormGroup>
          <FormGroup controlId="confirmPassword" className="form-label-group">
            <FormControl
              type={this.state.confirmPasswordInputType}
              onChange={this.handleChange}
              value={this.state.confirmPassword}
              placeholder={intl.get("Confirm_Password_Text")}
              className="form-control"
              disabled = {this.state.confirmedPasswordDisabled}
              required
            />
            <a
              onClick={(event) => {
              this.state.confirmPasswordInputType === "password"
                ? this.setState({ confirmPasswordInputType: "text" })
                : this.setState({ confirmPasswordInputType: "password" });
              }}
            >
              <i
              className={
                !this.state.confirmedPasswordDisabled ?
                this.state.confirmPasswordInputType === "password"
                ? "fa fa-eye-slash fa-flip-horizontal"
                : "fa fa-eye"
                : null
              }
              style={{
                color: "gray",
                right: "16px",
                position: "absolute",
                top: "17px",
              }}
              aria-hidden="true"
              />
            </a>
          </FormGroup>
          <LoaderButton
            block
            type="submit"
            className="btn btn-lg btn-primary btn-block btn-signin text-center"
            bsSize="large"
            text="Confirm"
            loadingText="Confirm…"
            isLoading={this.state.isConfirming}
            disabled={!this.validateResetForm()}
          />
          {(!this.state.confirmed || this.state.isChangePasswordFailed) ? (
            <div id="divError">
              <span style={{ color: "red", whiteSpace:"break-spaces" }}>{this.state.failedMessage}</span>
            </div>
          ) : null}
        </form>
      </DivsPattern>
    );
  }

  renderSuccessMessage() {
    return (
      <DivsPattern headerText={intl.get("Forgot_Password_Title")}>
        <div className="form-label-group">
          <p>
            {intl.get("Forgot_Password_Successfully_Reset") +
              ". " +
              intl.get("Forgot_Password_Go_To_Account")}
          </p>
          <div className="text-center">
            <Link to="/signIn">{intl.get("Sign_In")}</Link>
          </div>
        </div>
      </DivsPattern>
    );
  }

  render() {
    return !this.state.confirmed
      ? this.renderConfirmationForm()
      : this.renderSuccessMessage();
  }
}

export default ResetPassword;
